import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { ELIGIBILITY_CRITERIA_ACTION_TYPE } from '../actions';

const initialState = {};

const eligibilityBuilderCriteriaReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case ELIGIBILITY_CRITERIA_ACTION_TYPE.GET_ELIGIBILITY_CRITERIA:
        return payload || initialState;

      case ELIGIBILITY_CRITERIA_ACTION_TYPE.CREATE_ELIGIBILITY_CRITERIA:
      case ELIGIBILITY_CRITERIA_ACTION_TYPE.EDIT_ELIGIBILITY_CRITERIA:
        draft[payload.criteriaId] = payload;
        break;

      case ELIGIBILITY_CRITERIA_ACTION_TYPE.DELETE_ELIGIBILITY_CRITERIA:
        delete draft[meta.criteriaId];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default eligibilityBuilderCriteriaReducer;
